import userSlice from "../slices/UserSlice";
import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../store/index";
import { LoggedInUserModel, UserModel } from "../../models/UserModel";
import UserService from "../../services/UserService";
import { setStorageValue, removeStorageValue } from "../../utility/utils";
import { appConfig } from "../../utility/config";

export const userActions = userSlice.actions;

export const fetchUsers = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(userActions.setIsFetching(true));
    const response: UserModel[] = await UserService.getAllUsers();
    dispatch(userActions.setUsers(response));
    dispatch(userActions.setIsFetching(false));
  };
};

export const fetchParticularUser = (
  user_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: UserModel = await UserService.getParticularUser(user_id);
    dispatch(userActions.setParticularUser(response));
  };
};

export const validateLoggedInUser = (
  userEmail: string,
  userPassword: string
) => {
  return async (dispatch: any) => {
    dispatch(userActions.setIsFetching(true));
    const response: LoggedInUserModel =
      await UserService.validateUserCredentials(userEmail, userPassword);
    if (response?.userId === 0) {
      response.loggedIn = false;
    } else {
      response.loggedIn = true;
    }
    setStorageValue(appConfig.loginUserStorageKey, response);
    dispatch(userActions.setIsFetching(false));
    dispatch(userActions.setLoggedInUser(response));
    return response;
  };
};

export const setLoggedInUser = (
  data: LoggedInUserModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(userActions.setLoggedInUser(data));
  };
};

export const logOutUser = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return (dispatch) => {
    removeStorageValue(appConfig.loginUserStorageKey);
    dispatch(userActions.logOutUser());
  };
};

export const resetParticularUser = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return (dispatch) => {
    dispatch(userActions.resetParticularUser());
  };
};

export const setIsAdmin = (
  id: number,
  status: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(userActions.setIsFetching(true));
    await UserService.setIsAdmin(id, status);
    dispatch(userActions.setIsAdmin({ id, status }));
    dispatch(userActions.setIsFetching(false));
  };
};

export const setIsImportantEmailReceiver = (
  id: number,
  status: boolean
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(userActions.setIsFetching(true));
    await UserService.setIsImportantEmailReceiver(id, status);
    dispatch(userActions.setIsImportantEmailReceiver({ id, status }));
    dispatch(userActions.setIsFetching(false));
  };
};
